export const apiBaseUrl =
  process.env.REACT_APP_API_BASE_URL ||
  (window._env_ || {}).REACT_APP_API_BASE_URL ||
  "https://api-ecommerceweek.coredatalink.io";
export class Api {
  async patch(url, body, headers) {
    return await fetch(`${apiBaseUrl}${url}`, {
      method: "PATCH",
      headers: {
        ...headers,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
  }
  async patchWithAuth(url, body, user, headers) {
    return await this.patch(url, body, {
      Authorization: `JWT ${user?.token}`,
      ...headers,
    });
  }

  async post(url, body, headers) {
    return await fetch(`${apiBaseUrl}${url}`, {
      method: "POST",
      headers: {
        ...headers,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
  }
  async postWithAuth(url, body, user, headers) {
    return await this.post(url, body, {
      Authorization: `JWT ${user?.token}`,
      ...headers,
    });
  }
  async postFormData(url, body, headers) {
    return await fetch(`${apiBaseUrl}${url}`, {
      method: "POST",
      headers: {
        ...headers,
      },
      body: body,
    });
  }
  async postFormDataWithAuth(url, body, user, headers) {
    return await this.postFormData(url, body, {
      Authorization: `JWT ${user?.token}`,
      ...headers,
    });
  }

  async get(url, headers) {
    return await fetch(`${apiBaseUrl}${url}`, {
      headers,
    });
  }
  async getWithAuth(url, user, headers) {
    return await this.get(url, {
      Authorization: `JWT ${user?.token}`,
      ...headers,
    });
  }
  static getAdminUrl = (url) => url?.replace("https://api-", "https://admin-");
}
